<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-accounting-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>บันทึกบัญชีรายรับรายจ่าย</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>วันที่ทำรายการ</label>
                                        <div class="input-datepicker">
                                            <datepicker :input-class="[ 'input-field', (errorData.date.blank ? 'invalid' : '') ]"
                                                calendar-class="gadget-datepicker-box"
                                                format="d/M/yyyy"
                                                v-model="formData.date">
                                            </datepicker>
                                            <b-icon icon="calendar2-minus"></b-icon>
                                        </div>
                                        <div class="input-error-message" v-if="errorData.date.blank">โปรดใส่วันที่ทำรายการ</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="field">
                                        <label>หัวข้อรายการ</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.title.blank }"
                                                maxlength="200"
                                                placeholder="หัวข้อรายการ"
                                                v-model="formData.title" />
                                        <div class="input-error-message" v-if="errorData.title.blank">โปรดกรอกหัวข้อรายการ</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="field">
                                        <label>รายรับ</label>
                                        <input type="tel" 
                                                class="input-field"
                                                maxlength="10"
                                                placeholder="รายรับ"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.revenue" />
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="field">
                                        <label>รายจ่าย</label>
                                        <input type="tel" 
                                                class="input-field"
                                                maxlength="10"
                                                placeholder="รายจ่าย"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.expense" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>นำส่งภาษี</label>
                                        <input type="tel" 
                                                class="input-field"
                                                maxlength="10"
                                                placeholder="นำส่งภาษี"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.tax" />
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="saveAccounting()">บันทึก</button>
                                <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import DBAccounting from '@/database/Accounting';

export default {
    data() {
        return {
            isActive: false,
            formData: null,
            errorData: null
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: [Number, String]
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        async initFormData() {
            let data = null;

            if (this.keyData) {
                data = await DBAccounting.getDetail(this.keyData);
            }

            return this.mapViewData(data);
        },
        mapViewData(data) {
            return {
                key: data ? data.key : '',
                date: data ? data.date : new Date(),
                title: data ? data.title : '',
                revenue: data ? data.revenue : '',
                expense: data ? data.expense : '',
                tax: data ? data.tax : '',
                reference: data ? data.reference : '',
                bookNumber: data ? data.bookNumber : 1,
                originalBook: data ? data.originalBook : '',
                isClonable: data ? data.isClonable : true
            }
        },
        initValidateData() {
            return {
                date: { blank: false },
                title: { blank: false }
            }
        },
        async saveAccounting() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();

                await DBAccounting.save(this.formData);
                
                this.hide(true);
                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (typeof this.formData[property] === 'string' || this.formData[property] instanceof String) {
                    if (!this.formData[property].trim()) {
                        this.errorData[property].blank = true;
                        valid = false;
                    }
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-accounting-form {
    max-width: 800px;
}
</style>